import React from 'react';
import { Message, Icon } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { Button } from 'semantic-ui-react';
import logo from "../../images/logo/logo-white.png";
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import LoadingComponent from "../common/LoadingComponent";
import ModalHeader from './../drive/ModalHeader';
import mailImage from './../../images/grafix-banner/gfx-account-success.svg';

const errorLabel = (
    <div
        className="customErrorLabel"
        style={{
            position: 'absolute',
            bottom: '-16px',
            left: '10px',
            color: 'red',
            fontSize: '8px'
        }}
    />
);

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.goToLogin = this.goToLogin.bind(this);
    }

    onSubmit(formData) {
        dispatch.forgot.forgotAsync(formData);
    }

    goToLogin(e) {
        e.preventDefault();
        const { history } = this.props;
        history.push('/login');
    }

    render() {

        const { forgotSuccess, loading, forgotError, version } = this.props;
        return (
            <div className="login-main" style={{ height: '100%' }}>
                <LoadingComponent active={loading} message="Loading..." />
                <div className="left-section">
                    <div className='centered' style={{ justifyContent: "flex-start", paddingTop: "80px" }}>
                        <h2 className="f_24 ff_b float-left" style={{ color: "#707070", fontWeight: "normal", display: "flex", alignItems: "center", gap: "8px", paddingLeft: "10px" }}>
                            <a href="#" onClick={this.goToLogin} id="backLink" style={{
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: "28px", height: "28px",
                                border: "1px solid #d4d4d4", borderRadius: "6px",
                                color: "#707070", textDecoration: "none"
                            }}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="15 18 9 12 15 6"></polyline>
                                </svg>
                            </a>
                            Forgot Password
                        </h2>

                        {forgotSuccess === true ?
                            <div style={{ paddingLeft: "10px", paddingRight: "24px", maxWidth: "400px" }}>
                                <p style={{ fontSize: "13px", fontWeight: "500", color: "#555" }}>
                                    Check your inbox. We have sent an email confirmation to notify you on how to reset your password.
                                </p>
                                <p style={{ fontSize: "13px" }}>
                                    <a href="#" onClick={this.goToLogin} className="typeAnchor underline-hover" style={{ color: "#3EA2F7" }}>Click here</a> to go to the login page
                                </p>
                                <div>
                                    <img src={mailImage} height="160" alt='' />
                                </div>
                            </div>

                            : <Form
                                className="loginform"
                                error
                                ref={ref => this.form = ref}
                                onValidSubmit={this.onSubmit}
                                id="forgotpasswordform"
                            >
                                <div style={{ paddingLeft: "10px", marginBottom: "16px" }}>
                                    <span style={{ fontSize: "13px", fontWeight: "500", color: "#707070" }}>
                                        Enter your email address to receive instructions to reset your password.
                                    </span>
                                </div>
                                {forgotError ?
                                    <Message
                                        error
                                        content={`Invalid Email Address!`}
                                    /> : ''}
                                <div style={{ paddingLeft: "10px", position: "relative", marginBottom: "18px" }}>
                                    <Form.Input
                                        name="email"
                                        label="Email"
                                        placeholder="Enter Email"
                                        icon="envelope"
                                        iconPosition="left"
                                        required
                                        validations="isEmail"
                                        errorLabel={errorLabel}
                                        validationErrors={{
                                            isEmail: 'This is not a valid email',
                                            isDefaultRequiredValue: 'Email is required',
                                        }}
                                        id="emailId"
                                        autoFocus
                                        style={{ marginTop: "1px" }}
                                    />
                                </div>

                                <div style={{ paddingLeft: "10px" }}>
                                    <a href="#" className="typeAnchor underline-hover" onClick={this.goToLogin} id="loginLink" style={{ display: "block", marginBottom: "10px", fontSize: "12px", fontWeight: "500", color: "#3EA2F7" }}>Back to Login</a>
                                    <Button className="button-submit ff_sb" type="submit" id="submit" style={{ width: "100%" }}>Submit</Button>
                                </div>
                            </Form>
                        }
                    </div>
                    <div className="f_8 mar_0 bottom" style={{ height: "46px", padding: "5px 10px", width: "100%" }}>
                        <div className="float-left">
                            Copyright &#169; {new Date().getFullYear()} Aspenify <br />Version {version ? version : ""}
                        </div>
                        <div className="float-right text-right">
                            Visit us at <br />
                            <a href="https://www.aspenify.com" rel="noopener noreferrer" style={{ color: "#6b6b6b" }} target="_blank" > www.aspenify.com </a>
                        </div>
                    </div>
                </div>

                <div className="right-section display-flex " style={{ flexDirection: 'column' }}>
                    <div className='login-right-div '>
                        <div>
                            <ModalHeader
                                header={<a href="https://aspenify.com" target="_blank" rel="noopener noreferrer"><img src={`${logo}`} alt="Logo" style={{ width: '40vw', height: 'auto', cursor: 'pointer' }} /></a>}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        forgotSuccess: state.forgot.forgotPwdSuccess,
        loading: state.loading.effects.forgot.forgotAsync,
        forgotError: state.forgot.forgotPwdError,
        version: state.login.version
    };
}

const connectedLoginPage = connect(mapStateToProps)(ForgotPassword);

export default connectedLoginPage;
